import React from 'react';
import { useApp } from '../context/AppContext';

const TABS = [
  { id:'main',  icon:'🏪', label:'Vender'    },
  { id:'cart',  icon:'🛒', label:'Carrito'   },
  { id:'cfg',   icon:'⚙️', label:'Configurar'},
  { id:'stats', icon:'📊', label:'Reportes'  },
];

const S = {
  nav: { display:'flex', background:'var(--bg1)', borderTop:'0.5px solid var(--bd)', height:54, flexShrink:0 },
  btn: { flex:1, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:2, background:'none', border:'none', cursor:'pointer', padding:4, position:'relative' },
  ic:  { fontSize:19, lineHeight:1 },
  lb:  { fontSize:9, color:'var(--t2)', fontWeight:500 },
  lbon:{ fontSize:9, color:'var(--acc)', fontWeight:700 },
  bar: { position:'absolute', bottom:0, left:'20%', right:'20%', height:2, background:'var(--acc)', borderRadius:'2px 2px 0 0' },
};

export default function BottomNav() {
  const { page, setPage, cart } = useApp();
  const cartCount = cart.length; // número de ítems, no suma de cantidades

  return (
    <nav style={S.nav}>
      {TABS.map(t => {
        const on = page === t.id;
        const badge = t.id === 'cart' && cartCount > 0 ? cartCount : null;
        return (
          <button key={t.id} style={S.btn} onClick={() => setPage(t.id)}>
            <div style={{ position:'relative' }}>
              <span style={S.ic}>{t.icon}</span>
              {badge && (
                <div style={{ position:'absolute', top:-4, right:-8, background:'var(--acc)', color:'#fff', borderRadius:8, fontSize:9, fontWeight:800, padding:'1px 5px', minWidth:16, textAlign:'center' }}>
                  {badge}
                </div>
              )}
            </div>
            <span style={on ? S.lbon : S.lb}>{t.label}</span>
            {on && <div style={S.bar}/>}
          </button>
        );
      })}
    </nav>
  );
}
